import NewRnPlatformEmailPopup from "../../../modules/communication/components/rn-platform/NewRnPlatformEmailPopup";
import { useNewRnPlatformEmail } from "../../hooks/useNewRnPlatformEmail";
import { useReactBridgeDispatchEvent } from "../../hooks/useReactBridgeEvent";

function NewRnPlatformEmailPopupListener() {
  const { state, onOpen, onClose } = useNewRnPlatformEmail();

  useReactBridgeDispatchEvent({
    eventName: "COMM_CENTER:OPEN_NEW_RN_PLATFORM_EMAIL_POPUP",
    onEvent: (data) => {
      onOpen(data);
    },
  });

  if (state === null) {
    return <></>;
  }

  return (
    <NewRnPlatformEmailPopup
      key={JSON.stringify(state.patientDocumentIds)}
      {...state}
      onClose={onClose}
    />
  );
}

export default NewRnPlatformEmailPopupListener;
